/**
 * Meraki Locale Selector Modal - Mobile Version
 * Handles the full-screen locale selector modal for mobile devices
 * Mobile Only (< 1100px)
 */

// Immediately define the global function - this runs as soon as the script loads
(function() {
  window.openLocaleMobileModal = function() {
    const modal = document.getElementById('locale-selector-modal-mobile');
    
    if (modal) {
      // Remove hidden attribute
      modal.removeAttribute('hidden');
      
      // Force display with inline style
      modal.style.display = 'flex';
      
      // Add body class to prevent scrolling
      document.body.classList.add('locale-modal-mobile-open');
      
      // Set up close button if not already set up
      const closeButton = modal.querySelector('.locale-modal-mobile__close');
      if (closeButton && !closeButton.hasAttribute('data-listener-added')) {
        closeButton.setAttribute('data-listener-added', 'true');
        closeButton.addEventListener('click', function() {
          modal.setAttribute('hidden', '');
          modal.style.display = 'none';
          document.body.classList.remove('locale-modal-mobile-open');
        });
      }
    } else {
      console.error('LocaleSelectorModalMobile: Modal element not found!');
    }
  };
})();

class LocaleSelectorModalMobile {
  constructor() {
    // Only initialize on mobile
    if (window.innerWidth >= 1100) return;

    this.modal = document.getElementById('locale-selector-modal-mobile');
    
    if (!this.modal) return;

    this.searchInput = document.getElementById('locale-search-input-mobile');
    this.searchClear = this.modal.querySelector('.locale-modal-mobile__search-clear');
    this.regionButtons = this.modal.querySelectorAll('.locale-modal-mobile__region');
    this.countryItems = this.modal.querySelectorAll('.locale-modal-mobile__country-item');
    this.closeButton = this.modal.querySelector('.locale-modal-mobile__close');
    this.form = document.getElementById('locale-modal-mobile-form');
    this.noResults = this.modal.querySelector('.locale-modal-mobile__no-results');

    this.localeSelectorModalTrigger = document.getElementById('meraki-locale-mobile-trigger');
    this.localeSelectorModal = document.getElementById('locale-selector-modal-mobile');

    this.localeContent = this.modal.querySelector('.locale-modal-mobile__content');
    this.localeCommonItem = this.modal.querySelectorAll('[data-region-content="Common"] .locale-modal-mobile__country-item');

    this.bindEvent()

    this.init();
  }

  init() {
    if (!this.modal) return;

    // Bind events
    this.closeButton.addEventListener('click', () => this.close());
    this.searchInput.addEventListener('input', (e) => this.handleSearch(e.target.value));
    this.searchClear.addEventListener('click', () => this.clearSearch());

    this.regionButtons.forEach(btn => {
      btn.addEventListener('click', (e) => this.toggleRegion(e.currentTarget));
    });

    this.countryItems.forEach(item => {
      item.addEventListener('click', (e) => this.selectCountry(e.currentTarget, e));
    });

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.modal.hasAttribute('hidden')) {
        this.close();
      }
    });

    // Expose open method globally (override fallback)
    window.openLocaleMobileModal = () => {
      this.open();
    };
  }

  bindEvent() {
    const _that = this
    if (this.localeSelectorModalTrigger) {
      this.localeSelectorModalTrigger.addEventListener('click', function (event) {
        _that.localeSelectorModal.removeAttribute('hidden');
        _that.localeSelectorModal.style.display = 'flex';
        document.body.classList.add('locale-modal-mobile-open');
      })
    }
  }

  open() {
    console.log('LocaleSelectorModalMobile: open() called');
    
    // Only open on mobile
    if (window.innerWidth >= 1100) {
      console.log('LocaleSelectorModalMobile: Skipping open - desktop viewport');
      return;
    }

    if (!this.modal) {
      console.error('LocaleSelectorModalMobile: Cannot open - modal not found');
      return;
    }

    console.log('LocaleSelectorModalMobile: Opening modal');
    console.log('LocaleSelectorModalMobile: Before - hidden:', this.modal.hasAttribute('hidden'), 'display:', window.getComputedStyle(this.modal).display);
    
    // Remove hidden attribute
    this.modal.removeAttribute('hidden');
    
    // Force display with inline style as backup
    this.modal.style.display = 'flex';
    
    // Add body class
    document.body.classList.add('locale-modal-mobile-open');
    
    console.log('LocaleSelectorModalMobile: After - hidden:', this.modal.hasAttribute('hidden'), 'display:', window.getComputedStyle(this.modal).display);
    
    // Focus search input after a short delay
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }, 100);
  }

  close() {
    this.modal.setAttribute('hidden', '');
    document.body.classList.remove('locale-modal-mobile-open');
    document.body.classList.remove('overflow-hidden-tablet');
    
    // Clear search and collapse all regions
    this.clearSearch();
    this.collapseAllRegions();

    if (window.merakiUtils && window.merakiUtils.localStorageSet) {
      window.merakiUtils.localStorageSet()
    }
  }

  toggleRegion(regionButton) {
    const region = regionButton.dataset.region;
    const countriesContainer = this.modal.querySelector(`[data-region-content="${region}"]`);
    
    if (!countriesContainer) return;

    const isExpanded = countriesContainer.classList.contains('expanded');

    if (isExpanded) {
      // Collapse this region
      countriesContainer.classList.remove('expanded');
      regionButton.classList.remove('expanded');
    } else {
      // Collapse all other regions first
      this.collapseAllRegions();
      
      // Expand this region
      countriesContainer.classList.add('expanded');
      regionButton.classList.add('expanded');
    }
  }

  collapseAllRegions() {
    // Collapse all country containers
    this.modal.querySelectorAll('.locale-modal-mobile__countries').forEach(container => {
      container.classList.remove('expanded');
    });
    
    // Remove expanded class from all region buttons
    this.regionButtons.forEach(btn => {
      btn.classList.remove('expanded');
    });
  }

  handleSearch(searchTerm) {
    const term = searchTerm.toLowerCase().trim();

    const searchLoadingClass = 'is-loading'
    if (this.localeContent && !this.localeContent.classList.contains(searchLoadingClass)) {
      this.localeContent.classList.add(searchLoadingClass)
    }

    if (term === '') {
      this.localeCommonItem.forEach(item => {
        item.removeAttribute('hidden')
      })
      this.localeContent.classList.remove(searchLoadingClass)

      // Hide clear button
      this.searchClear.style.display = 'none';
      
      // Show all countries
      this.showAllCountries();
      
      // Collapse all regions
      // this.collapseAllRegions();
      
      // Hide no results message
      this.noResults.style.display = 'none';
      
      return;
    }

    this.localeCommonItem.forEach(item => {
      const counryName = item.querySelector('.locale-modal-mobile__country-name')
      if (counryName) {
        const text = counryName.textContent.toLowerCase()
        if (text.includes(term)) {
          item.removeAttribute('hidden')
        } else {
          item.setAttribute('hidden', true)
        }
      }
    })

    // Show clear button
    // this.searchClear.style.display = 'block';

    // // Expand all regions to show search results
    // this.modal.querySelectorAll('.locale-modal-mobile__countries').forEach(container => {
    //   container.classList.add('expanded');
    // });
    
    // this.regionButtons.forEach(btn => {
    //   btn.classList.add('expanded');
    // });

    // // Filter countries
    // let hasResults = false;

    // this.countryItems.forEach(item => {
    //   const searchText = item.dataset.searchText || '';
      
    //   if (searchText.includes(term)) {
    //     item.style.display = 'flex';
    //     hasResults = true;
    //   } else {
    //     item.style.display = 'none';
    //   }
    // });

    // // Show/hide no results message
    // if (hasResults) {
    //   this.noResults.style.display = 'none';
    // } else {
    //   this.noResults.style.display = 'block';
    // }

    // // Hide empty regions
    // this.hideEmptyRegions();
  }

  hideEmptyRegions() {
    this.modal.querySelectorAll('.locale-modal-mobile__region-wrapper').forEach(wrapper => {
      const countriesContainer = wrapper.querySelector('.locale-modal-mobile__countries');
      const visibleCountries = Array.from(countriesContainer.querySelectorAll('.locale-modal-mobile__country-item'))
        .filter(item => item.style.display !== 'none');
      
      if (visibleCountries.length === 0) {
        wrapper.style.display = 'none';
      } else {
        wrapper.style.display = 'block';
      }
    });
  }

  clearSearch() {
    this.searchInput.value = '';
    this.searchClear.style.display = 'none';
    this.showAllCountries();
    this.noResults.style.display = 'none';
    
    // Show all region wrappers
    this.modal.querySelectorAll('.locale-modal-mobile__region-wrapper').forEach(wrapper => {
      wrapper.style.display = 'block';
    });
  }

  showAllCountries() {
    this.countryItems.forEach(item => {
      item.style.display = 'flex';
    });
  }

  selectCountry(item, event) {
    if (window.merakiUtils && window.merakiUtils.localStorageSet) {
      window.merakiUtils.localStorageSet()
    }

    const countryCode = item.dataset.country;
    // const languageCode = item.dataset.defaultLanguage;
    const defaultLang = window.Shopify?.locale || 'en';

    // Set form values
    const countryInput = this.form.querySelector('input[name="country_code"]');
    const localeInput = this.form.querySelector('input[name="locale_code"]');
    
    const parentButDom = item
    const redirectPath = parentButDom.dataset.redirectPath;
    const currencyCode = parentButDom.dataset.currencyCode;

    if (event.target.classList.contains('locale-modal__language-option')) {
      const languageCode = event.target.dataset.language;

      if (parentButDom.getAttribute('data-action') === 'default') {
        if (window.merakiUtils && window.merakiUtils.submitCountryForm && window.merakiUtils.filterRedirectPath) {
          const returnHref = window.merakiUtils.filterRedirectPath(redirectPath)
          window.merakiUtils.submitCountryForm(countryCode, returnHref, languageCode, currencyCode)
        }
        return
      }

      if (countryInput && localeInput) {
        countryInput.value = countryCode;
        localeInput.value = languageCode;
        
        const form = this.form;
          
        // 这里是站内跳转的特殊处理，对 CA AUS EU 等站点做处理
        if (window.merakiUtils && window.merakiUtils.formatReturnHref) {
          const returnHrefDom = form.querySelector('input[name="return_to"]');
          let returnTo = returnHrefDom ? returnHrefDom.value : '';
          returnTo = window.merakiUtils.formatReturnHref(returnTo, countryCode)
          returnHrefDom.value = returnTo;
        }
        // Submit form
        this.form.submit();
      }
      return
    }

    if (item.getAttribute('data-action') === 'default') {
      if (window.merakiUtils && window.merakiUtils.submitCountryForm && window.merakiUtils.filterRedirectPath) {
        const returnHref = window.merakiUtils.filterRedirectPath(redirectPath)
        window.merakiUtils.submitCountryForm(countryCode, returnHref, defaultLang, currencyCode)
      }
      return
    }

    if (!countryCode || !defaultLang) {
      console.error('Missing country or language code');
      return;
    }

    if (countryInput && localeInput) {
      countryInput.value = countryCode;
      localeInput.value = defaultLang;

      const form = this.form;
        
      // 这里是站内跳转的特殊处理，对 CA AUS EU 等站点做处理
      if (window.merakiUtils && window.merakiUtils.formatReturnHref) {
        const returnHrefDom = form.querySelector('input[name="return_to"]');
        let returnTo = returnHrefDom ? returnHrefDom.value : '';
        returnTo = window.merakiUtils.formatReturnHref(returnTo, countryCode)
        returnHrefDom.value = returnTo;
      }

      // Submit form
      this.form.submit();
    } else {
      console.error('Form inputs not found');
    }
  }
}

// Initialize when DOM is ready - Mobile Only
function initMobileModal() {
  if (window.innerWidth < 1100) {
    window.mobileModalInstance = new LocaleSelectorModalMobile();
  } else {
  }
}

// Try multiple initialization strategies
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileModal);
} else if (document.readyState === 'interactive' || document.readyState === 'complete') {
  initMobileModal();
}

// Also try on window load as a fallback
window.addEventListener('load', () => {
  if (!window.mobileModalInstance && window.innerWidth < 1100) {
    initMobileModal();
  }
});

// Re-initialize on window resize if crossing the mobile threshold
let resizeTimer_mobile = null;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer_mobile);
  resizeTimer_mobile = setTimeout(() => {
    // Close modal if switching from mobile to desktop
    if (window.innerWidth >= 1100) {
      const modal = document.getElementById('locale-selector-modal-mobile');
      if (modal && !modal.hasAttribute('hidden')) {
        document.body.classList.remove('locale-modal-mobile-open');
        modal.setAttribute('hidden', '');
      }
    }
  }, 250);
});

